import { Component, inject } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog, IDialogData } from '../dialog';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-reset-changes-dialog',
  templateUrl: './reset-changes-dialog.component.html',
  standalone: true,
  imports: [DialogComponent],
})
export class ResetChangesDialogComponent extends Dialog<IDialogData> {
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
}
